export class SignatureEntry {
    constructor(key, file) {
        this.key = key;
        this.file = file;
    }
}
